import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  bookDropYears,
  DEFAULT_BOOK_DROP_YEAR,
  parseBookDropYear,
  SUPPORTED_BOOK_DROP_YEARS,
  type BookDrop,
} from '../data/bookDrops';
import '../styles/BookDrops.css';

function BookDropCard({ drop }: { drop: BookDrop }) {
  return (
    <div className="book-drop">
      <h3>Book Drop {drop.number}</h3>
      <p>
        <strong>{drop.title}</strong>
      </p>
      {drop.description && <p>{drop.description}</p>}
      {drop.additionalDescription && <p>{drop.additionalDescription}</p>}
      {drop.images.length > 0 && (
        <div className="book-drop-images">
          {drop.images.map((image) => (
            <img key={image.alt} src={image.src} alt={image.alt} />
          ))}
        </div>
      )}
    </div>
  );
}

const BookDrops: React.FC = () => {
  const [searchParams] = useSearchParams();
  const year = parseBookDropYear(searchParams.get('year'));
  const config = bookDropYears[year];
  const archiveYears = SUPPORTED_BOOK_DROP_YEARS.filter((supportedYear) => supportedYear !== year);

  return (
    <div className="book-drops-container">
      <h1>BOOK DROP LOCATIONS ({year})</h1>

      {config.introText && (
        <div className="book-drops-intro">
          <p>{config.introText}</p>
        </div>
      )}

      {config.showFullMap && config.fullMap && (
        <div className="full-course-map">
          <img src={config.fullMap.src} alt={config.fullMap.alt} />
        </div>
      )}

      <div className="book-drops-app-recommendation">
        <p>
          <strong>Your best option for navigating to each book drop is the Allegheny County Parks Trails app.</strong>
        </p>
        <ul>
          <li>
            <a
              href="https://experience.arcgis.com/experience/685285b63f42477f90fc1a92e7f01dc8/page/Page?views=Park"
              target="_blank"
              rel="noopener noreferrer"
            >
              Use the web version
            </a>
          </li>
          <li>
            <a
              href="https://apps.apple.com/us/app/allegheny-county-parks-trails/id1092687884"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download for iPhone
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=us.alleghenycounty.alleghenycountyparkstrails&hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download for Android
            </a>
          </li>
        </ul>
      </div>

      {config.drops.map((drop) => (
        <BookDropCard key={drop.number} drop={drop} />
      ))}

      {archiveYears.length > 0 && (
        <div className="book-drops-archive">
          {archiveYears.map((archiveYear) => (
            <Link key={archiveYear} to={`/book-drops?year=${archiveYear}`}>
              View {archiveYear} book drops
            </Link>
          ))}
          {year !== DEFAULT_BOOK_DROP_YEAR && (
            <Link to="/book-drops">Back to current book drops</Link>
          )}
        </div>
      )}
    </div>
  );
};

export default BookDrops;
